import { useState } from 'react';

import { Button } from '../../../common/Button';
import { Dialog } from '../../../common/Dialog';
import { GoalHeader } from '../../../common/Goal';
import Header from '../../../common/Header';
import { CheckInTabs } from '../components/CheckInTabs';
import { GeneratedSummaryProps } from '../components/CustomTextEditor';
import StandupSummary from '../components/StandupSummary';
import { useStandupSummary } from '../hooks/useStandupSummary';

export function CheckInContainer(): JSX.Element {
  const [isSummaryDialogOpen, setIsSummaryDialogOpen] = useState(false);
  const { generatedSummary, isLoading, generateSummary } = useStandupSummary();
  const handleClose = (): void => setIsSummaryDialogOpen(false);
  const handleOpen = async (): Promise<void> => {
    setIsSummaryDialogOpen(true);
    await generateSummary();
  };

  return (
    <div className="flex flex-col justify-center items-start gap-3 self-stretch mt-4 max-w-screen-l mx-auto">
      <div className="flex flex-row justify-between items-center gap-2 self-stretch">
        <Header>Check-In</Header>
        <Button
          onClick={() => {
            handleOpen().catch(console.error);
          }}
          variant="primary"
          className="truncate"
        >
          Get Daily Summary
        </Button>
      </div>
      <Dialog
        isOpen={isSummaryDialogOpen}
        onClose={handleClose}
        title="Daily Standup Update Summary"
      >
        <StandupSummary
          isLoading={isLoading}
          generatedSummary={generatedSummary as GeneratedSummaryProps}
        />
      </Dialog>
      <GoalHeader />
      <CheckInTabs />
    </div>
  );
}
